/**
 * Decodificador de audio para el cliente (Frontend).
 * 
 * Permite decodificar grabaciones de Asterisk en formato WAV49 / MS-GSM (0x0031)
 * a formato WAV PCM 16-bit estándar nativamente en el navegador sin requerir
 * procesos de transcodificación en el servidor backend (Hardening Estricto).
 * 
 * También maneja archivos que ya se encuentren en formato PCM WAV, OGG u MP3.
 */

import { GSMDecoder } from './gsm/GSMDecoder.js';

const GSM_MAGIC = 0xD;

/**
 * Empaqueta parámetros GSM en una trama estándar de 33 bytes de libgsm / GSM 06.10
 */
function writeGSM_33(c, LARc, Nc, bc, Mc, xmaxc, xmc) {
    let i = 0;
    c[i++] = ((GSM_MAGIC & 0xF) << 4) | ((LARc[0] >> 2) & 0xF);
    c[i++] = ((LARc[0] & 0x3) << 6) | (LARc[1] & 0x3F);
    c[i++] = ((LARc[2] & 0x1F) << 3) | ((LARc[3] >> 2) & 0x7);
    c[i++] = ((LARc[3] & 0x3) << 6) | ((LARc[4] & 0xF) << 2) | ((LARc[5] >> 2) & 0x3);
    c[i++] = ((LARc[5] & 0x3) << 6) | ((LARc[6] & 0x7) << 3) | (LARc[7] & 0x7);
    c[i++] = ((Nc[0] & 0x7F) << 1) | ((bc[0] >> 1) & 0x1);
    c[i++] = ((bc[0] & 0x1) << 7) | ((Mc[0] & 0x3) << 5) | ((xmaxc[0] >> 1) & 0x1F);
    c[i++] = ((xmaxc[0] & 0x1) << 7) | ((xmc[0] & 0x7) << 4) | ((xmc[1] & 0x7) << 1) | ((xmc[2] >> 2) & 0x1);
    c[i++] = ((xmc[2] & 0x3) << 6) | ((xmc[3] & 0x7) << 3) | (xmc[4] & 0x7);
    c[i++] = ((xmc[5] & 0x7) << 5) | ((xmc[6] & 0x7) << 2) | ((xmc[7] >> 1) & 0x3);
    c[i++] = ((xmc[7] & 0x1) << 7) | ((xmc[8] & 0x7) << 4) | ((xmc[9] & 0x7) << 1) | ((xmc[10] >> 2) & 0x1);
    c[i++] = ((xmc[10] & 0x3) << 6) | ((xmc[11] & 0x7) << 3) | (xmc[12] & 0x7);
    c[i++] = ((Nc[1] & 0x7F) << 1) | ((bc[1] >> 1) & 0x1);
    c[i++] = ((bc[1] & 0x1) << 7) | ((Mc[1] & 0x3) << 5) | ((xmaxc[1] >> 1) & 0x1F);
    c[i++] = ((xmaxc[1] & 0x1) << 7) | ((xmc[13] & 0x7) << 4) | ((xmc[14] & 0x7) << 1) | ((xmc[15] >> 2) & 0x1);
    c[i++] = ((xmc[15] & 0x3) << 6) | ((xmc[16] & 0x7) << 3) | (xmc[17] & 0x7);
    c[i++] = ((xmc[18] & 0x7) << 5) | ((xmc[19] & 0x7) << 2) | ((xmc[20] >> 1) & 0x3);
    c[i++] = ((xmc[20] & 0x1) << 7) | ((xmc[21] & 0x7) << 4) | ((xmc[22] & 0x7) << 1) | ((xmc[23] >> 2) & 0x1);
    c[i++] = ((xmc[23] & 0x3) << 6) | ((xmc[24] & 0x7) << 3) | (xmc[25] & 0x7);
    c[i++] = ((Nc[2] & 0x7F) << 1) | ((bc[2] >> 1) & 0x1);
    c[i++] = ((bc[2] & 0x1) << 7) | ((Mc[2] & 0x3) << 5) | ((xmaxc[2] >> 1) & 0x1F);
    c[i++] = ((xmaxc[2] & 0x1) << 7) | ((xmc[26] & 0x7) << 4) | ((xmc[27] & 0x7) << 1) | ((xmc[28] >> 2) & 0x1);
    c[i++] = ((xmc[28] & 0x3) << 6) | ((xmc[29] & 0x7) << 3) | (xmc[30] & 0x7);
    c[i++] = ((xmc[31] & 0x7) << 5) | ((xmc[32] & 0x7) << 2) | ((xmc[33] >> 1) & 0x3);
    c[i++] = ((xmc[33] & 0x1) << 7) | ((xmc[34] & 0x7) << 4) | ((xmc[35] & 0x7) << 1) | ((xmc[36] >> 2) & 0x1);
    c[i++] = ((xmc[36] & 0x3) << 6) | ((xmc[37] & 0x7) << 3) | (xmc[38] & 0x7);
    c[i++] = ((Nc[3] & 0x7F) << 1) | ((bc[3] >> 1) & 0x1);
    c[i++] = ((bc[3] & 0x1) << 7) | ((Mc[3] & 0x3) << 5) | ((xmaxc[3] >> 1) & 0x1F);
    c[i++] = ((xmaxc[3] & 0x1) << 7) | ((xmc[39] & 0x7) << 4) | ((xmc[40] & 0x7) << 1) | ((xmc[41] >> 2) & 0x1);
    c[i++] = ((xmc[41] & 0x3) << 6) | ((xmc[42] & 0x7) << 3) | (xmc[43] & 0x7);
    c[i++] = ((xmc[44] & 0x7) << 5) | ((xmc[45] & 0x7) << 2) | ((xmc[46] >> 1) & 0x3);
    c[i++] = ((xmc[46] & 0x1) << 7) | ((xmc[47] & 0x7) << 4) | ((xmc[48] & 0x7) << 1) | ((xmc[49] >> 2) & 0x1);
    c[i++] = ((xmc[49] & 0x3) << 6) | ((xmc[50] & 0x7) << 3) | (xmc[51] & 0x7);
}

/**
 * Desempaqueta un bloque Microsoft GSM (65 bytes) en dos tramas estándar de 33 bytes (conv65)
 */
function conv65(c, d1, d2) {
    let ci = 0;
    let sr = 0;
    const LARc = new Uint32Array(8);
    const Nc = new Uint32Array(4);
    const Mc = new Uint32Array(4);
    const bc = new Uint32Array(4);
    const xmaxc = new Uint32Array(4);
    const xmc = new Uint32Array(52);

    sr = c[ci++];
    LARc[0] = sr & 0x3f; sr >>>= 6;
    sr |= c[ci++] << 2;
    LARc[1] = sr & 0x3f; sr >>>= 6;
    sr |= c[ci++] << 4;
    LARc[2] = sr & 0x1f; sr >>>= 5;
    LARc[3] = sr & 0x1f; sr >>>= 5;
    sr |= c[ci++] << 2;
    LARc[4] = sr & 0xf; sr >>>= 4;
    LARc[5] = sr & 0xf; sr >>>= 4;
    sr |= c[ci++] << 2;
    LARc[6] = sr & 0x7; sr >>>= 3;
    LARc[7] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 4;
    Nc[0] = sr & 0x7f; sr >>>= 7;
    bc[0] = sr & 0x3; sr >>>= 2;
    Mc[0] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 1;
    xmaxc[0] = sr & 0x3f; sr >>>= 6;
    xmc[0] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[1] = sr & 0x7; sr >>>= 3;
    xmc[2] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[3] = sr & 0x7; sr >>>= 3;
    xmc[4] = sr & 0x7; sr >>>= 3;
    xmc[5] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[6] = sr & 0x7; sr >>>= 3;
    xmc[7] = sr & 0x7; sr >>>= 3;
    xmc[8] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[9] = sr & 0x7; sr >>>= 3;
    xmc[10] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[11] = sr & 0x7; sr >>>= 3;
    xmc[12] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 4;
    Nc[1] = sr & 0x7f; sr >>>= 7;
    bc[1] = sr & 0x3; sr >>>= 2;
    Mc[1] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 1;
    xmaxc[1] = sr & 0x3f; sr >>>= 6;
    xmc[13] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[14] = sr & 0x7; sr >>>= 3;
    xmc[15] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[16] = sr & 0x7; sr >>>= 3;
    xmc[17] = sr & 0x7; sr >>>= 3;
    xmc[18] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[19] = sr & 0x7; sr >>>= 3;
    xmc[20] = sr & 0x7; sr >>>= 3;
    xmc[21] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[22] = sr & 0x7; sr >>>= 3;
    xmc[23] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[24] = sr & 0x7; sr >>>= 3;
    xmc[25] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 4;
    Nc[2] = sr & 0x7f; sr >>>= 7;
    bc[2] = sr & 0x3; sr >>>= 2;
    Mc[2] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 1;
    xmaxc[2] = sr & 0x3f; sr >>>= 6;
    xmc[26] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[27] = sr & 0x7; sr >>>= 3;
    xmc[28] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[29] = sr & 0x7; sr >>>= 3;
    xmc[30] = sr & 0x7; sr >>>= 3;
    xmc[31] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[32] = sr & 0x7; sr >>>= 3;
    xmc[33] = sr & 0x7; sr >>>= 3;
    xmc[34] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[35] = sr & 0x7; sr >>>= 3;
    xmc[36] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[37] = sr & 0x7; sr >>>= 3;
    xmc[38] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 4;
    Nc[3] = sr & 0x7f; sr >>>= 7;
    bc[3] = sr & 0x3; sr >>>= 2;
    Mc[3] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 1;
    xmaxc[3] = sr & 0x3f; sr >>>= 6;
    xmc[39] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[40] = sr & 0x7; sr >>>= 3;
    xmc[41] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[42] = sr & 0x7; sr >>>= 3;
    xmc[43] = sr & 0x7; sr >>>= 3;
    xmc[44] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[45] = sr & 0x7; sr >>>= 3;
    xmc[46] = sr & 0x7; sr >>>= 3;
    xmc[47] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[48] = sr & 0x7; sr >>>= 3;
    xmc[49] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[50] = sr & 0x7; sr >>>= 3;
    xmc[51] = sr & 0x7; sr >>>= 3;

    let frame_chain = sr & 0xf;
    writeGSM_33(d1, LARc, Nc, bc, Mc, xmaxc, xmc);

    sr = frame_chain;
    sr |= c[ci++] << 4;
    LARc[0] = sr & 0x3f; sr >>>= 6;
    LARc[1] = sr & 0x3f; sr >>>= 6;
    sr = c[ci++];
    LARc[2] = sr & 0x1f; sr >>>= 5;
    sr |= c[ci++] << 3;
    LARc[3] = sr & 0x1f; sr >>>= 5;
    LARc[4] = sr & 0xf; sr >>>= 4;
    sr |= c[ci++] << 2;
    LARc[5] = sr & 0xf; sr >>>= 4;
    LARc[6] = sr & 0x7; sr >>>= 3;
    LARc[7] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    Nc[0] = sr & 0x7f; sr >>>= 7;
    sr |= c[ci++] << 1;
    bc[0] = sr & 0x3; sr >>>= 2;
    Mc[0] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 5;
    xmaxc[0] = sr & 0x3f; sr >>>= 6;
    xmc[0] = sr & 0x7; sr >>>= 3;
    xmc[1] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[2] = sr & 0x7; sr >>>= 3;
    xmc[3] = sr & 0x7; sr >>>= 3;
    xmc[4] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[5] = sr & 0x7; sr >>>= 3;
    xmc[6] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[7] = sr & 0x7; sr >>>= 3;
    xmc[8] = sr & 0x7; sr >>>= 3;
    xmc[9] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[10] = sr & 0x7; sr >>>= 3;
    xmc[11] = sr & 0x7; sr >>>= 3;
    xmc[12] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    Nc[1] = sr & 0x7f; sr >>>= 7;
    sr |= c[ci++] << 1;
    bc[1] = sr & 0x3; sr >>>= 2;
    Mc[1] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 5;
    xmaxc[1] = sr & 0x3f; sr >>>= 6;
    xmc[13] = sr & 0x7; sr >>>= 3;
    xmc[14] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[15] = sr & 0x7; sr >>>= 3;
    xmc[16] = sr & 0x7; sr >>>= 3;
    xmc[17] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[18] = sr & 0x7; sr >>>= 3;
    xmc[19] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[20] = sr & 0x7; sr >>>= 3;
    xmc[21] = sr & 0x7; sr >>>= 3;
    xmc[22] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[23] = sr & 0x7; sr >>>= 3;
    xmc[24] = sr & 0x7; sr >>>= 3;
    xmc[25] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    Nc[2] = sr & 0x7f; sr >>>= 7;
    sr |= c[ci++] << 1;
    bc[2] = sr & 0x3; sr >>>= 2;
    Mc[2] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 5;
    xmaxc[2] = sr & 0x3f; sr >>>= 6;
    xmc[26] = sr & 0x7; sr >>>= 3;
    xmc[27] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[28] = sr & 0x7; sr >>>= 3;
    xmc[29] = sr & 0x7; sr >>>= 3;
    xmc[30] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[31] = sr & 0x7; sr >>>= 3;
    xmc[32] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[33] = sr & 0x7; sr >>>= 3;
    xmc[34] = sr & 0x7; sr >>>= 3;
    xmc[35] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[36] = sr & 0x7; sr >>>= 3;
    xmc[37] = sr & 0x7; sr >>>= 3;
    xmc[38] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    Nc[3] = sr & 0x7f; sr >>>= 7;
    sr |= c[ci++] << 1;
    bc[3] = sr & 0x3; sr >>>= 2;
    Mc[3] = sr & 0x3; sr >>>= 2;
    sr |= c[ci++] << 5;
    xmaxc[3] = sr & 0x3f; sr >>>= 6;
    xmc[39] = sr & 0x7; sr >>>= 3;
    xmc[40] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[41] = sr & 0x7; sr >>>= 3;
    xmc[42] = sr & 0x7; sr >>>= 3;
    xmc[43] = sr & 0x7; sr >>>= 3;
    sr = c[ci++];
    xmc[44] = sr & 0x7; sr >>>= 3;
    xmc[45] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 2;
    xmc[46] = sr & 0x7; sr >>>= 3;
    xmc[47] = sr & 0x7; sr >>>= 3;
    xmc[48] = sr & 0x7; sr >>>= 3;
    sr |= c[ci++] << 1;
    xmc[49] = sr & 0x7; sr >>>= 3;
    xmc[50] = sr & 0x7; sr >>>= 3;
    xmc[51] = sr & 0x7; sr >>>= 3;

    writeGSM_33(d2, LARc, Nc, bc, Mc, xmaxc, xmc);
}

/**
 * Decodifica un ArrayBuffer de audio a un Blob URL estándar reproducible por HTML5 <audio>
 * @param {ArrayBuffer} arrayBuffer - Buffer con el contenido del archivo de audio
 * @returns {Promise<{ blobUrl: string, isTranscoded: boolean, sampleRate: number }>}
 */
export async function decodeAudioToPlayableUrl(arrayBuffer) {
    if (!arrayBuffer || arrayBuffer.byteLength < 12) {
        throw new Error('Archivo de audio inválido o vacío.');
    }

    const view = new DataView(arrayBuffer);
    const u8 = new Uint8Array(arrayBuffer);

    // 1. Detección de encabezado RIFF/WAVE
    const isRiff = String.fromCharCode(u8[0], u8[1], u8[2], u8[3]) === 'RIFF';
    const isWave = isRiff && String.fromCharCode(u8[8], u8[9], u8[10], u8[11]) === 'WAVE';

    if (!isWave) {
        // Puede ser Ogg (OggS), MP3 u otro formato web nativo
        let mime = 'audio/wav';
        if (String.fromCharCode(u8[0], u8[1], u8[2], u8[3]) === 'OggS') {
            mime = 'audio/ogg';
        } else if (u8[0] === 0xFF && (u8[1] & 0xE0) === 0xE0) {
            mime = 'audio/mpeg';
        }
        const blob = new Blob([arrayBuffer], { type: mime });
        return {
            blobUrl: URL.createObjectURL(blob),
            isTranscoded: false,
            sampleRate: 8000
        };
    }

    // 2. Localizar chunk 'fmt ' y 'data'
    let offset = 12;
    let audioFormat = null;
    let sampleRate = 8000;
    let dataOffset = null;
    let dataSize = null;

    while (offset + 8 <= arrayBuffer.byteLength) {
        const chunkId = String.fromCharCode(u8[offset], u8[offset + 1], u8[offset + 2], u8[offset + 3]);
        const chunkSize = view.getUint32(offset + 4, true);

        if (chunkId === 'fmt ') {
            audioFormat = view.getUint16(offset + 8, true);
            sampleRate = view.getUint32(offset + 12, true);
        } else if (chunkId === 'data') {
            dataOffset = offset + 8;
            dataSize = Math.min(chunkSize, arrayBuffer.byteLength - dataOffset);
            break;
        }

        offset += 8 + chunkSize;
        // Ajuste de alineación par RIFF
        if (chunkSize % 2 !== 0) offset++;
    }

    // 3. Si el formato ya es PCM (0x0001), no requiere decodificación
    if (audioFormat === 0x0001) {
        const blob = new Blob([arrayBuffer], { type: 'audio/wav' });
        return {
            blobUrl: URL.createObjectURL(blob),
            isTranscoded: false,
            sampleRate
        };
    }

    // 4. Si el formato es GSM 6.10 / WAV49 (0x0031 = 49)
    if (audioFormat === 0x0031) {
        if (!dataOffset || dataSize < 65) {
            throw new Error('Datos de audio GSM insuficientes o corruptos.');
        }

        const blocks = Math.floor(dataSize / 65);
        const decoder = new GSMDecoder();
        const pcmChunks = [];
        const d1 = new Uint8Array(33);
        const d2 = new Uint8Array(33);

        for (let b = 0; b < blocks; b++) {
            const blockStart = dataOffset + b * 65;
            const block = u8.subarray(blockStart, blockStart + 65);
            conv65(block, d1, d2);
            const pcm1 = decoder.decode(d1);
            const pcm2 = decoder.decode(d2);
            pcmChunks.push(pcm1);
            pcmChunks.push(pcm2);
        }

        // Construir archivo WAV PCM 16-bit Mono 8000Hz estándar
        const totalSamples = blocks * 320;
        const pcmByteLength = totalSamples * 2;
        const wavBuffer = new ArrayBuffer(44 + pcmByteLength);
        const wavView = new DataView(wavBuffer);
        const wavU8 = new Uint8Array(wavBuffer);

        // RIFF Header
        writeString(wavU8, 0, 'RIFF');
        wavView.setUint32(4, 36 + pcmByteLength, true);
        writeString(wavU8, 8, 'WAVE');

        // fmt subchunk
        writeString(wavU8, 12, 'fmt ');
        wavView.setUint32(16, 16, true); // Subchunk1Size (16 for PCM)
        wavView.setUint16(20, 1, true);  // AudioFormat (1 = PCM)
        wavView.setUint16(22, 1, true);  // NumChannels (1 = Mono)
        wavView.setUint32(24, 8000, true); // SampleRate (8000 Hz)
        wavView.setUint32(28, 16000, true); // ByteRate (8000 * 1 * 2)
        wavView.setUint16(32, 2, true);  // BlockAlign (1 * 2)
        wavView.setUint16(34, 16, true); // BitsPerSample (16 bits)

        // data subchunk
        writeString(wavU8, 36, 'data');
        wavView.setUint32(40, pcmByteLength, true);

        // Copiar muestras PCM
        let sampleOffset = 44;
        for (let c = 0; c < pcmChunks.length; c++) {
            const chunk = pcmChunks[c];
            for (let s = 0; s < chunk.length; s++) {
                wavView.setInt16(sampleOffset, chunk[s], true);
                sampleOffset += 2;
            }
        }

        const blob = new Blob([wavBuffer], { type: 'audio/wav' });
        return {
            blobUrl: URL.createObjectURL(blob),
            isTranscoded: true,
            sampleRate: 8000
        };
    }

    // Si es un formato no soportado directamente, intentar entregar el blob original
    const fallbackBlob = new Blob([arrayBuffer], { type: 'audio/wav' });
    return {
        blobUrl: URL.createObjectURL(fallbackBlob),
        isTranscoded: false,
        sampleRate
    };
}

function writeString(u8, offset, str) {
    for (let i = 0; i < str.length; i++) {
        u8[offset + i] = str.charCodeAt(i);
    }
}
